import { APP_PLATFORM_VERSION } from '@semios/app-platform-version'

// Intentionally a separate list from backend-logger's SENTRY_ENVIRONMENTS: banyan-app's
// VITE_SENTRY_ENVIRONMENT is set to the frontend deploy names (no 'ag-radar', a regional-api
// deploy), so any unrecognized value safely falls back to 'local' (Sentry disabled).
const SENTRY_ENVIRONMENTS = ['prod', 'stage', 'future', 'demo', 'testing', 'replica', 'dev', 'local'] as const

export type SentryEnvironment = (typeof SENTRY_ENVIRONMENTS)[number]

const resolveSentryEnvironment = (raw: string | undefined): SentryEnvironment =>
  (SENTRY_ENVIRONMENTS as readonly string[]).includes(raw ?? '') ? (raw as SentryEnvironment) : 'local'

export const appInfo = {
  APP_PLATFORM_VERSION: APP_PLATFORM_VERSION,
  apiURL: import.meta.env.VITE_API_URL,
  deploymentDate: import.meta.env.VITE_DEPLOYMENT_DATE,
  gitBranchName: import.meta.env.VITE_GIT_BRANCH_NAME,
  gitCommitHash: import.meta.env.VITE_GIT_COMMIT_HASH,
  useHubspot: import.meta.env.VITE_USE_HUBSPOT === 'true',
  useSentry: import.meta.env.VITE_USE_SENTRY === 'true',
  sentryEnvironment: resolveSentryEnvironment(import.meta.env.VITE_SENTRY_ENVIRONMENT),
}
